// extracted by mini-css-extract-plugin
export default {"card":"UnlockingPotentialCard1_card__hajeS","div1":"UnlockingPotentialCard1_div1__b3oqt","div2":"UnlockingPotentialCard1_div2__wj8iS","div3":"UnlockingPotentialCard1_div3__sOklY"};